import { PinOutline } from '@lyearn/icons';
import { QuestionTypeEnum } from '@/types/schema';

import { QuizViewField } from '../../../types';
import { getQuestionEvaluation } from '../../../utils';
import ImageHotspotPlayer from '../../ImageHotspotPlayer';
import QuestionReview from '../../QuestionReview';
import { isValidImageHotspotSubmission } from '../../utils';

const ImageHotspotViewField: QuizViewField = {
  getQuestionEvaluation,
  isValidSubmission: isValidImageHotspotSubmission,
  Player: ImageHotspotPlayer,
  type: QuestionTypeEnum.ImageHotspot,
  getQuestionLabel: () => 'QuizPlayer:QuestionType.ImageHotspotLabel',
  labelKey: 'QuizPlayer:QuestionType.ImageHotspot',
  Icon: PinOutline,
  Review: QuestionReview,
};

export default ImageHotspotViewField;
